export default function initM9() {
const $ = jQuery
$(window).on("load",function(){
   var owl2 = $('.owl-scrollingLogoRight');
   owl2.owlCarousel({
      center: true,
      autoWidth:true,
      loop:true,
      items:4,
      margin:15,
      rtl:false,
      autoplay: true,
      slideTransition: 'linear',
      autoplayTimeout: 6000,
      autoplaySpeed: 6000, mouseDrag:false
   });
   var owl3 = $('.owl-scrollingLogoLeft');
   owl3.owlCarousel({
      center: true,
      autoWidth:true,
      loop:true,
      items:4,
      margin:15,
      autoplay: true,
      rtl:true,
      slideTransition: 'linear',
      autoplayTimeout: 6000,
      autoplaySpeed: 6000, mouseDrag:false
   });
});
}